import React from 'react'

// query
import { useQuery } from '@apollo/client'
import { GET_JOB_BY_ID_WITH_CUSTOMER } from '../../../../graphql/job/job.queries'

// components
import Card from '../../../../components/cards/Card/Card.component'
import CardDataPoint from '../../../../components/cards/CardDataPoint/CardDataPoint.component'

// icons
import { FontAwesomeIcon  } from '@fortawesome/react-fontawesome'
import { faUserTie } from '@fortawesome/free-solid-svg-icons'

export default function JobCustomer({ id }) {
    let job = {}
    const { loading, error, data } = useQuery(GET_JOB_BY_ID_WITH_CUSTOMER, {
        variables: { id }
    })

    if(data && data.job) {
        job = {...data.job}
    }

    return (<Card header={{ icon: <FontAwesomeIcon icon={faUserTie} size='2x' color='#707070' />, title: 'Customer'}}>
        <CardDataPoint label='Name' value={job.customerName} isLoading={loading} />
        <CardDataPoint label='Contact Name' value={job.customerContactName} isLoading={loading} />
        <CardDataPoint label='Phone' value={job.customerPhone} isLoading={loading} />
        <CardDataPoint label='Email' value={job.customerEmail} isLoading={loading} />
    </Card>)
}